<template>
  <div>
    <div class="row">
      <div class="col-6">
        <button class="btn btn-light" @click="refresh()"><i class="fa fa-sync fa-fw" aria-hidden="true"></i> Refresh</button>
        <button class="btn btn-danger" @click="clearLog()"><i class="fa fa-trash fa-fw" aria-hidden="true"></i> Clear Log</button>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-8">
        <table class="table table-hover table-sm">
          <tbody>
          <tr v-for="log_event in log" :key="log_event.log_id">
            <td>[{{ log_event.message_timestamp.format('M/D/YY hh:mm:ss a') }}]: <pre>{{ log_event.message }}</pre></td>
          </tr>
          </tbody>
        </table>
        <nav>
          <ul class="pagination">
            <li class="page-item" v-for="n in log_total_pages"
                :key="n"
                :class="{ 'active': n === log_current_page }">
              <a class="page-link" href="#" v-if="n === 1"
                 onclick="return false"
                 @click="loadLog(n)">{{ n }}</a>
              <a class="page-link" v-else-if="n === (log_current_page - 4)">
                ...
              </a>
              <a class="page-link" href="#" v-else-if="(n) <= (log_current_page + 3) && n >= (log_current_page - 3)"
                 onclick="return false"
                 @click="loadLog(n)">{{ n }}</a>
              <a class="page-link" href="#" v-else-if="n === log_total_pages"
                 onclick="return false"
                 @click="loadLog(n)">{{ n }}</a>
              <a class="page-link" v-else-if="n === (log_current_page + 4)">
                ...
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      log: 'allLog',
      log_total_pages: 'logTotalPages',
      log_current_page: 'logCurrentPage',
      scoped_site_id: 'scopedSiteId'
    })
  },
  created () {
    this.$store.dispatch('getLog', {
      page: '1'
    })
  },
  watch: {
    scoped_site_id (newScopedSiteId, oldScopedSiteId) {
      this.$store.dispatch('getLog', {
        page: '1'
      })
    }
  },
  methods: {
    loadLog (page) {
      this.$store.dispatch('getLog',
        {
          page: page
        }
      )
    },
    refresh () {
      this.$store.dispatch('getLog', {
        page: '1'
      })
    },
    clearLog () {
      this.$store.dispatch('clearLog')
    }
  }
}
</script>

<style scoped>

</style>
